import { useQuery } from '@tanstack/react-query';
import { getPlanVsRealYear } from './dashboard-service';
import { dashboardKeys } from './keys';

/** Plan vs real del año seleccionado; refetch automático al cambiar de año
 *  (nuevo query key). Endpoint separado del dashboard principal para que el
 *  cambio de año no refetchee el resto del tablero. */
export function usePlanVsRealYear(year: string) {
  return useQuery({
    queryKey: dashboardKeys.planVsRealYear(year),
    queryFn: () => getPlanVsRealYear(year),
    staleTime: 60_000,
  });
}
